module.exports = __webpack_public_path__ + "static/column2-b72e9e9b8936623a9c7dd23dae10e85f.jpg";